import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
import { ROUTE_BASE_URL } from '../api/common';

const ProtectedRoute = ({ component: Component, ...rest }) => {
    
    // const isAuthenticated = localStorage.getItem('loginUserId');
    const isAuthenticated = Cookies.get('userId');

    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthenticated ? <Component {...props} /> : <Redirect to={`${ROUTE_BASE_URL}/login`} />
            }
        />
    );
};

export default ProtectedRoute;
